function Guard() {
    this.forNullOrEmpty = function(value) {
        return value ? true : false;
    };

    this.forFunction = function(fn) {
        return typeof fn === "function";
    };

    this.forDate = function(date) {
        return date instanceof Date;
    };

    this.forISOString = function(value){
        var regex = /^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*)?)([zZ]|([+\-])(\d\d):?(\d\d))?$/g;
        if (value.match(regex)){
            return true;
        }
        else{
            return false;
        }
    };
}

module.exports = new Guard();


// WEBPACK FOOTER //
// ./src-client-lib/api/guard.js